import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import taskValidator from './cannot-be-treated-validator'

export default {
    taskName: taskName.REVIEW_TREATMENT_PLAN_INTERNAL,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.TREATMENT_DURATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.TREATMENT_PLAN_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.TREATMENT_VISUALIZATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_PLAN_FILE_UPLOAD_WIDGET,
            readOnly: true,
        },
    ],
    actionList: [
        {
            action: processAction.PROCESS_INSTANCE,
            taskPath: ['processInstance'],
        },
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
        {
            action: processAction.QUOTATION_CUSTOMER_LOADED,
            taskPath: ['objectDetail', 'customer'],
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator,
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/review-treatment-plan-internal.js